import { apiRequest } from "../../services/apiService";
import Axios from "axios";
import {
  ADD_USER_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  CHANGE_USER_STATUS_FAIL,
  CHANGE_USER_STATUS_REQUEST,
  CHANGE_USER_STATUS_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  GET_USER_DATA_FAIL,
  GET_USER_DATA_REQUEST,
  GET_USER_DATA_SUCCESS,
  GET_USER_LIST_DATA_FAIL,
  GET_USER_LIST_DATA_REQUEST,
  GET_USER_LIST_DATA_SUCCESS,
  UPDATE_PROFILE_PICTURE,
  PROFILE_IMAGE_CHECK_REQUEST,
  PROFILE_IMAGE_CHECK_SUCCESS,
  PROFILE_IMAGE_CHECK_FAIL,
} from "../constant";

export const getUserList = (
  data = {
    startingLimit: 0,
    resultsPerPage: 10,
    search: "",
  }
) => {
  return async (dispatch) => {
    //dispatch({ type: GET_USER_LIST_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/getUserList`,
      data: data,
    });
    if (response) {
      // dispatch({ type: GET_USER_LIST_DATA_SUCCESS, payload: response?.data });

      // dispatch({ type: GET_USER_LIST_DATA_REQUEST, payload: response?.data });
      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_USER_LIST_DATA_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_USER_LIST_DATA_FAIL });
    }
  };       
};

export const addUser = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: ADD_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/addUser`,
      data: data,
    });
    if (response?.data?.result === "success" && Number(response.data.statusCode) === 200) {
      dispatch({ type: ADD_USER_SUCCESS });
      dispatch(getUserList());
      if (typeof callback === "function") callback(null, response);
    } else {
      dispatch({ type: ADD_USER_FAIL });
      if (typeof callback === "function") callback(error || new Error(response?.data?.msg || "Could not add user."));
    }
  };
};

export const editUser = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/updateUser`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_USER_SUCCESS });
      dispatch(getUserList());
      if (typeof callback === "function") callback(null, response);
    } else if (error) {
      dispatch({ type: EDIT_USER_FAIL });
      if (typeof callback === "function") callback(error);
    }
  };
};

export const changeStatus = (data) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_USER_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/changeStatus`,
      data: data,
    });
    if (response) {
      dispatch({ type: CHANGE_USER_STATUS_SUCCESS });
    } else if (error) {
      dispatch({ type: CHANGE_USER_STATUS_FAIL });
    }
  };
};

export const deleteUser = (data) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/users/deleteUser`,
      data: data,
    });
    if (response) {
      dispatch({ type: DELETE_USER_SUCCESS });
      dispatch(getUserList());
    } else if (error) {
      dispatch({ type: DELETE_USER_FAIL });
    }
  };
};


export const userDetail = () => {
  return async (dispatch) => {
    dispatch({ type: GET_USER_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/getMyProfileData`,
    });
    if (response) {
      dispatch({ type: GET_USER_DATA_SUCCESS, payload: response.data.data });
      getUserList();
    } else if (error) {
      dispatch({ type: GET_USER_DATA_FAIL });
    }
  };
};

export const updateProfileData = (data) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/updateProfileData`,
      data: data,
    });
    if (response) {
      dispatch({ type: EDIT_USER_SUCCESS });
      getUserList();
    } else if (error) {
      dispatch({ type: EDIT_USER_FAIL });
    }
  };
};

export const removeProfileData = (data) => {
  return async (dispatch) => {
    dispatch({ type: PROFILE_IMAGE_CHECK_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/removeProfile`,
      data: data,
    });
    if (response) {
      dispatch({ type: PROFILE_IMAGE_CHECK_FAIL });
    } else if (error) {
      dispatch({ type: PROFILE_IMAGE_CHECK_SUCCESS });
    }
  };
};


// export const updateProfileimg = (email) => {
//   return async (dispatch) => {
//     dispatch({ type: UPDATE_PROFILE_PICTURE });
//     const { response, error } = await apiRequest({
//       method: "POST",
//       url: `/users/profileimage`,
//       data: {email},
//     });
//     if (response) {
//       const profileImage = response.data.profileImages;
//       dispatch({ type: UPDATE_PROFILE_PICTURE, payload: profileImage });
//       // dispatch({ type: EDIT_USER_SUCCESS });
//       // getUserList();
//     } else if (error) {
//       // dispatch({ type: EDIT_USER_FAIL });
//       console.error("Error fetching profile image:", error);
//     }
//   };
// };


export const checkProfileImageExistence = (email) => {
  return async (dispatch) => {
    try {
      dispatch({ type: PROFILE_IMAGE_CHECK_REQUEST });

      // const response = await Axios.post(`${process.env.REACT_APP_NODE_API_URL}/users/profileimage`, { email });
      const { response, error } = await apiRequest({
        method: "POST",
        url: `/users/profileimage`,
        data: {email},
      });

      if (response.data.status) {
        dispatch({ type: PROFILE_IMAGE_CHECK_SUCCESS, payload: response.data.profileImages });
      } else {
        dispatch({ type: PROFILE_IMAGE_CHECK_FAIL });
      }
    } catch (error) {
      // console.error('Error checking profile image existence:', error.message);
      dispatch({ type: PROFILE_IMAGE_CHECK_FAIL });
    }
  };
};



export const uploadProfilePicture = (profilePicture, userId) => {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append('profilePicture', profilePicture);
      formData.append('user_id', userId);

      // const { response, error } = await apiRequest({
      //   method: "POST",
      //   url: `/users/uploadProfilePicture`,
      //   formData,
      //   headers: {
      //     'Content-Type': 'multipart/form-data'
      //   }
      // });

      const response = await Axios.post(`${process.env.REACT_APP_NODE_API_URL}/users/uploadProfilePicture`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      dispatch(updateProfilePicture(response.data.image_name));

      // console.log('Profile Picture Uploaded Successfully');
    } catch (error) {
      console.error('Error uploading profile picture:', error.message);
      dispatch({ type: PROFILE_IMAGE_CHECK_FAIL });
      // toast.error('An Error Occurred While Uploading Profile Picture');
    }
  };
};

export const updateProfilePicture = (profilePicture) => ({
  type: UPDATE_PROFILE_PICTURE,
  payload: profilePicture,
});
